export const workerKeys = {
    all: ['workers'] as const,
    list: (workerTypeId?: string, includeArchived?: boolean) =>
        [...workerKeys.all, 'list', workerTypeId ?? 'all', includeArchived ?? false] as const,
    detail: (workerId: string) => [...workerKeys.all, 'detail', workerId] as const,
    assignments: (workerId: string, dateFrom: string, dateTo: string) =>
        [...workerKeys.all, 'assignments', workerId, dateFrom, dateTo] as const,
    allAssignments: () => [...workerKeys.all, 'assignments'] as const,
    timeEntries: (workerId: string, limit: number) =>
        [...workerKeys.all, 'time-entries', workerId, limit] as const,
}
